import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 16px 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const InputPlaceholder = styled.div`
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const FeeTierGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
`;

const FeeButton = styled.button`
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #3b82f6;
    color: rgba(255, 255, 255, 0.8);
  }
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  font-weight: 600;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: not-allowed;
  margin-top: 8px;
`;

const InfoBox = styled.div`
  padding: 12px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 8px;
  margin-top: 16px;
`;

const InfoText = styled.p`
  font-size: 11px;
  color: #60a5fa;
  margin: 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
  line-height: 1.4;
  
  strong {
    font-weight: 600;
  }
`;

interface AddLiquidityContainerProps {
  onPoolCreated?: (poolAddress: string) => void;
}

export const AddLiquidityContainer: React.FC<AddLiquidityContainerProps> = ({ onPoolCreated }) => {
  return (
    <Container>
      <Title>Create V3 Pool / Add Liquidity</Title>
      
      <FormSection>
        <div>
          <Label>Token A</Label>
          <InputPlaceholder>Select token...</InputPlaceholder>
        </div>

        <div>
          <Label>Token B</Label>
          <InputPlaceholder>Select token...</InputPlaceholder>
        </div>

        <div>
          <Label>Fee Tier</Label>
          <FeeTierGrid>
            <FeeButton>0.05%</FeeButton>
            <FeeButton>0.3%</FeeButton>
            <FeeButton>1%</FeeButton>
          </FeeTierGrid>
        </div>

        <div>
          <Label>Price Range</Label>
          <InputPlaceholder>Range selector will go here...</InputPlaceholder>
        </div>

        <div>
          <Label>Amount</Label>
          <InputPlaceholder>Enter amount...</InputPlaceholder>
        </div>

        <ActionButton disabled>
          Connect Wallet to Create Pool
        </ActionButton>
      </FormSection>

      <InfoBox>
        <InfoText>
          <strong>Note:</strong> This is a placeholder. The full Add Liquidity component from Reservoir Swap 
          will be integrated here. It will support creating new V3 pools and adding liquidity to existing pools.
        </InfoText>
      </InfoBox>
    </Container>
  );
};

